import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import {AuthService} from "./auth.service";
import { Observable } from "rxjs";



@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    

    // CTOR
    constructor(
        public readonly authService: AuthService
    ) { }

    // Intercept all requests and append bearer token if exists
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(this.isApiCall(request.url) && this.authService.isLoggedIn){

            request = request.clone({
                setHeaders: {
                    Authorization: this.authService.authorizationHeader
                }
            });
        }
        return next.handle(request);
    }

    isApiCall(url:string) : boolean {
        const lowered = url.toLowerCase();
        return lowered.startsWith("api") || lowered.startsWith("/api");
    }
    
}